!(function() {
  var e = window.location.search
    .slice(1)
    .split('&')
    .reduce((e, o) => ({ ...e, [o.split('=')[0]]: o.split('=')[1] }), {});
  const t = e.smsclickid;
  var e = e.smscode,
    o = (e = 30) => {
      var e = new Date().getTime() + 864e5 * e,
        o = new Date();
      return o.setTime(e), o.toUTCString();
    },
    { domain: c, expires: i } = (document.currentScript?.src?.split('?')[1] || '')
      .split('&')
      .reduce((e, o) => ({ ...e, [o.split('=')[0]]: o.split('=')[1] }), {});
  if (t) {
    c
      ? ((document.cookie = `sms_click_id=${t};domain=${c};expires=${o(i)};path=/;`),
        (document.cookie = `sms_click_time=${new Date().toUTCString()};domain=${c};expires=${o(i)};path=/;`))
      : ((document.cookie = `sms_click_id=${t};expires=${o(i)};path=/;`),
        (document.cookie = `sms_click_time=${new Date().toUTCString()};expires=${o(i)};path=/;`)),
      console.info(`ShopMy: Registered click ${t}.`);
    const s = e => {
      e = { clickId: t, shopifyCartApiSuccess: !!e, url: window.location.href };
      fetch('https://api.shopmy.us/api/confirm_click', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(e) })
        .then(e => e.json())
        .then(e => {
          e.success ? console.info(`ShopMy: Confirmed click ${t} with backend.`) : console.info(`ShopMy: Failed to confirm click ${t} with backend.`);
        })
        .catch(() => console.info(`ShopMy: Error confirming click ${t} with backend.`));
    };
    if (2 <= Array.from(document.querySelectorAll('[class*="shopify"]')).length) {
      const n = window.location.href.replace(/^(http|https):\/\//, '').split(/[/?#]/)[0],
        r = o =>
          fetch(`https://${n}/cart.js`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
            .then(e => e.json())
            .then(e => {
              e = { ...(e.attributes || {}), sms_click_id: t, sms_click_time: new Date().toUTCString() };
              fetch(`https://${n}/cart/update.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: e })
              })
                .then(() => {
                  o || console.info(`ShopMy: Sent tracking code ${t} to cart object.`), o || s(!0);
                })
                .catch(() => {
                  o || console.info(`ShopMy: Failed to send tracking code ${t} to cart object.`), o || s(!1);
                });
            });
      r(), setTimeout(() => r(!0), 2e3);
    } else s(!1);
  }
  e &&
    (2 <= Array.from(document.querySelectorAll('[class*="shopify"]')).length
      ? ((i = window.location.href.replace(/^(http|https):\/\//, '').split(/[/?#]/)[0]),
        fetch(`https://${i}/discount/` + e),
        console.info(`ShopMy: Automatically applied discount code ${e}.`))
      : ((document.cookie = c ? `sms_code=${e};domain=${c};expires=${o()};path=/;` : `sms_code=${e};expires=${o()};path=/;`),
        console.info(`ShopMy: Stored cookie for coupon ${e}.`)));
  i = () => {
    const { sms_click_id: o, sms_code: t } = document.cookie
      .split(';')
      .reduce((e, o) => ({ ...e, [(o.split('=')[0] || '').trim()]: (o.split('=')[1] || '').trim() }), {});
    o &&
      Array.from(document.querySelectorAll('a[href*=".myshopify"][href*="checkout"]')).forEach(e => {
        e.href.includes('smsclickid') ||
          (console.info('ShopMy Shelf: Migrating Cookie to Checkout URL'),
          (e.href = `${e.href}${e.href.includes('?') ? '&' : '?'}smsclickid=` + o + (t ? '&smscode=' + t : '')));
      });
  };
  setTimeout(i, 250), setInterval(i, 1750);
})();